import React from 'react'
import AmbulatoryPatientInfoLayout from 'presentation/doctor/layouts/AmbulatoryPatientInfo'

function AmbulatoryPatientInfo() {
  return <AmbulatoryPatientInfoLayout />
}

export default AmbulatoryPatientInfo
